export function swipersInit() {

    const swiperBanners = new Swiper('.swiper-banners', {
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        watchOverflow: true,
        speed: 700,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next.banners',
          prevEl: '.swiper-button-prev.banners',
        },
        pagination: {
          el: '.swiper-pagination.banners',
          clickable: true,
          type: "progressbar",
        },
      });
      
      const institutionalSwiper = new Swiper('.institutional-swiper', {
        slidesPerView: 1,
        spaceBetween: 15,
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next.institutional-next',
          prevEl: '.swiper-button-prev.institutional-prev',
        },
        pagination: {
          el: '.swiper-pagination.institutional',
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 3,
        },
      });

      const swiperBlogInternalRelated = new Swiper('.blog-internal-related-slider', {
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        slidesPerView: 1,
        watchOverflow: true,
        watchOverflow :true,
        navigation: {
          nextEl: '.swiper-button-next.blog-internal',
          prevEl: '.swiper-button-prev.blog-internal',
        },
        pagination: {
          el: '.swiper-pagination.blog-internal',
          clickable: true
        },
        breakpoints: {
          800: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        }
      });

      const swiperUsedModelInternalThumbs = new Swiper('.seminovos-detalhe-slider-thumbs', {
        slidesPerView: 4,
        freeMode: true,
        spaceBetween: 20,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: '.swiper-button-next.seminovos-slider-thumbs',
          prevEl: '.swiper-button-prev.seminovos-slider-thumbs',
        },
        breakpoints: {
          992: {
            slidesPerView: 4,
            spaceBetween: 16,
          }
        }
      });
    
      const usedModelInternalSwiper = new Swiper('.seminovos-detalhe-slider', {
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next.seminovos-slider',
          prevEl: '.swiper-button-prev.seminovos-slider',
        },
        clickable: true,
        thumbs: {
          swiper: swiperUsedModelInternalThumbs,
        },
      });

      const usedRelatedSwiper = new Swiper('.used-related-swiper', {
        slidesPerView: 1,
        spaceBetween: 15,
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next.used-related-next',
          prevEl: '.swiper-button-prev.used-related-prev',
        },
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          1400: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        }
      });

      const swiperNewModels = new Swiper ('.swiper-new-model', {
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        centerInsufficientSlides: true,
        watchOverflow: true,
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next.new-model',
          prevEl: '.swiper-button-prev.new-model',
        },
        breakpoints: {
          992: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1600: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
      });


      const swiperNewModelsHighlights = new Swiper ('.swiper-new-model-highlights', {
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        centerInsufficientSlides: true,
        watchOverflow: true,
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next.new-model-highlight',
          prevEl: '.swiper-button-prev.new-model-highlight',
        },
        breakpoints: {
          992: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 30,
          }
        },
      });
    
      const swiperNewModelVersion = new Swiper ('.swiper-new-model-version', {
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        watchOverflow: true,
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next.version',
          prevEl: '.swiper-button-prev.version',
        },
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 30,
          },
          1600: {
            slidesPerView: 6,
            spaceBetween: 30,
          },
        },
      });
    
                  
      const swiperHighlights = new Swiper('.swiper-highlights', {
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        centerInsufficientSlides: true,
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-button-next.highlights',
          prevEl: '.swiper-button-prev.highlights',
        },
        pagination: {
          el: '.swiper-pagination.highlights',
          clickable: true,
          type: "fraction",
        },
        breakpoints: {
          992: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
      });

      const swiperHomeBlog = new Swiper('.swiper-home-blog', {
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        centerInsufficientSlides: true,
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-button-next.home-blog',
          prevEl: '.swiper-button-prev.home-blog',
        },
        pagination: {
          el: '.swiper-pagination.home-blog',
          clickable: true,
          type: "fraction",
        },
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      });

      const swiperListPhones = new Swiper('.swiper-list-phones', {
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        centerInsufficientSlides: true,
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next.list-phones-nav',
          prevEl: '.swiper-button-prev.list-phones-nav'
        },
        pagination: {
          el: '.swiper-pagination.list-phones-nav',
          clickable: true,
        },
        breakpoints: {
          440: {
            slidesPerView: 2,
          },
          640: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 4,
          },
        },
      });

}